import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  clearCache() {
    window.Turbo.clearCache()
  }

  getTurboStream(e) {
    e.preventDefault()

    const options = {
      contentType: "text/vnd.turbo-stream.html",
      responseKind: "turbo-stream",
    }

    get(e.target.href, options)
      .then(response => response.responseText)
      .then(html => window.document.body.insertAdjacentHTML("beforeend", html))
      .then(() => e.target.dispatchEvent(new Event("ajaxSuccess")))
  }
}
